import { render, staticRenderFns } from "./privacidad.vue?vue&type=template&id=357a53c0&scoped=true&"
import script from "./privacidad.vue?vue&type=script&lang=js&"
export * from "./privacidad.vue?vue&type=script&lang=js&"
import style0 from "./privacidad.vue?vue&type=style&index=0&id=357a53c0&less=true&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357a53c0",
  null
  
)

export default component.exports